export const API_BASE = process.env.REACT_APP_API_BASE_URL || ''
export const api = (path) => {
  if (!path) return API_BASE
  if (API_BASE && !path.startsWith('http')) return `${API_BASE}${path.startsWith('/') ? '' : '/'}${path}`
  return path
}

// Authorization header from the stored token (used alongside credentials: 'include')
export const authHeaders = (extra = {}) => {
  const token = localStorage.getItem('authToken') || ''
  return token ? { Authorization: `Bearer ${token}`, ...extra } : { ...extra }
}
